import { memoize, groupBy, values } from 'lodash';
import { v4 as uuid } from 'uuid';
import { parseCookies } from '@cian/utils/lib/shared/cookie';

export interface ITeaserEventProps {
  soprApi: string;
  user_id: string | null;
  announcement_id?: number;
  pagenumber: number;
  position: number;
  pageType: string;
  device_type: string;
  ab_group: number | null;
  block_type: string;
  isTeaserShow: 1 | 0;
  sc: string;
}

const getSearchId = memoize((sc: string) => uuid());

export const getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
export const getViewportWidth = () => Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

export function sendTeaserEvent(events: Array<ITeaserEventProps>) {
  const viewport = {
    width: getViewportWidth(),
    height: getViewportHeight(),
  };
  const cid = parseCookies(document.cookie)['_CIAN_GK'];

  const uniqEventChunks = values(groupBy(events, 'sc'));

  uniqEventChunks.forEach(items => {
    const firstEvent = items[0];
    const { soprApi, user_id, ab_group, pageType, device_type, sc, pagenumber } = firstEvent;
    fetch(`${soprApi}teaser/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id,
        list_id: getSearchId(sc),
        device_type,
        viewport,
        ab_group,
        cid,
        pageType,
        pagenumber,
        sc,
        items: items.map(({ soprApi, user_id, ab_group, pageType, device_type, sc, pagenumber, ...props }) => props),
      }),
    });
  });
}
